import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import find from 'lodash/find'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import ReactList from 'react-list'
import { timesheetAction } from '../../../../actions'
import { timesheetSelector } from '../../../../selectors'
import { statusColor, approveStatus } from '../../helpers/color'
import { time_sheet_status_header, FONTS } from '../../../../constants'
import moment from '../../../../lib/moment.js'
import arrow_down_black from '../../../../static/images/arrow-down-black.svg'
import arrow_up_black from '../../../../static/images/arrow-up-black.svg'
import * as CONSTANTS from '../../constants'

const showApproverStatus = (approvers, users) => {
  return (
    approvers.map(approver => {
      const app = find(users, { _id: approver.approver_id })
      return (
        <div key={ shortid() } style={ { display: 'flex' } }>
          <Circle color={ statusColor(approver.status) } />
          { `${app.first_name} ${app.last_name}` }
        </div>
      )
    })
  )
}

const StatusTable = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'timesheetStatus', []))
    !== JSON.stringify(prevState.timesheetStatus)) {
      const options = get(nextProps, 'getOptionsTimesheetStatus')
      set(tempState, 'timesheetStatus', get(nextProps, 'timesheetStatus', []))
      let status = get(nextProps, 'timesheetStatus', [])

      const sortOrder = options.sortOrderStatus ? 'asc' : 'desc'
      const sortColumn = [
        (item) => {
          const order = {
            'PENDING': 1,
            'APPROVED': 2,
            'CANCEL': 3,
            'REJECTED': 4,
          }
          return order[item.status]
        },
        'approve_status',
        'month',
        'emp_code',
        ['first_name', 'last_name'],
        'lob_name',
        'department_name',
      ]
      status = orderBy(status, sortColumn[options.sortColumnStatus], sortOrder)
      set(tempState, 'status', status)
    }
    const options = get(nextProps, 'getOptionsTimesheetStatus')
    if (options && get(options, 'sortOrderStatus') !== prevState.sort_order) {
      set(tempState, 'sort_order', get(options, 'sortOrderStatus'))
    }
    if (options && get(options, 'sortColumnStatus') !== prevState.sort_column) {
      set(tempState, 'sort_column', get(options, 'sortColumnStatus'))
    }
    return tempState
  }

  state={
    sort_order: false,
    sort_column: 0,
    timesheetStatus: [],
    status: [],
  }

  handleClickSort(column) {
    const options = get(this.props, 'getOptionsTimesheetStatus')
    let { sort_order } = { ...this.state }
    const { timesheetStatus } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
      this.props.setOptionsTimesheetStatus({
        ...options,
        sortOrderStatus: sort_order,
        sortColumnStatus: column,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
      this.props.setOptionsTimesheetStatus({
        ...options,
        sortOrderStatus: false,
        sortColumnStatus: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    const sortColumn = [
      (item) => {
        const order = {
          'PENDING': 1,
          'APPROVED': 2,
          'CANCEL': 3,
          'REJECTED': 4,
        }
        return order[item.status]
      },
      'approve_status',
      'month',
      'emp_code',
      ['first_name', 'last_name'],
      'lob_name',
      'department_name',
    ]
    const newItems = orderBy(timesheetStatus, sortColumn[column], sort_order)
    this.setState({ status: newItems })
  }

  renderItem = (index, key) => {
    const { timesheets } = this.props
    const users = get(timesheets, 'users', [])
    const status = this.state.status[index]
    const showApprover = status.status !== CONSTANTS.UNSUBMITTED
    return (
      <tr
        key={ shortid() }
        style={ {
          hover: '#E5E5E5',
          backgroundColor: (key % 2 === 0) ? '#FFFFFF' : '#FFF8F8',
          cursor: status._id !== '' ? 'pointer' : '',
        } }
        onClick={ () => this.props.handleClickRow(status._id) }
      >
        <td style={ {
          display: 'flex',
          color: statusColor(status.status),
        } }
        >
          <Circle color={ statusColor(status.status) } />
          { approveStatus(status.status) }
        </td>
        <td>{ showApprover ? showApproverStatus(status.approve_status, users) : '-' }</td>
        <td>{ `${moment(status.month).year()} ${moment(moment(status.month).month('MM')).format('MMMM')}` }</td>
        <td>{ status.emp_code }</td>
        <td>{ `${status.first_name} ${status.last_name} (${status.nick_name})` }</td>
        <td>{ status.lob_name }</td>
        <td>{ status.department_name }</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, status } = this.state

    return (
      /* eslint no-underscore-dangle: 0 */
      <WrapTable>
        <NewTable bordered hover>
          <Header>
            <tr style={ { fontFamily: 'Gotham', borderBottom: '1px solid #cccccc' } }>
              {
                time_sheet_status_header.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up_black } alt="logo" />
                        :
                        <Icon src={ arrow_down_black } alt="logo" />
                    )
                    }
                  </HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ status.length }
              // type='variable'
            />
          </BodyTable>
        </NewTable>
      </WrapTable>
    )
  }
}

StatusTable.propTypes = {
  timesheets: PropTypes.object,
  handleClickRow: PropTypes.func,
  setOptionsTimesheetStatus: PropTypes.func.isRequired,
}
StatusTable.defaultProps = {
  timesheets: {},
  handleClickRow: () => {},
}

const mapStateToProps = (state, props) => createStructuredSelector({
  getOptionsTimesheetStatus: timesheetSelector.getOptionsTimesheetStatus,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  setOptionsTimesheetStatus: timesheetAction.setOptionsTimesheetStatus,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(StatusTable)

const NewTable = styled(Table)`
  height: 100%;
  background: white;
  margin-bottom: 0px !important;
  thead{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    background-color: #ffffff ;
  }tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border-bottom: 1px solid #cccccc;
  }thead th{
    border: none ;
    font-size: ${FONTS.SMALL_SIZE};
  }tbody td{
    border: none ;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const WrapTable = styled.div`
  padding-top: 10 ;
  padding-right: 15px;
  font-family: ${FONTS.GOTHAM} ;
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block;
  max-height: calc(100vh - 225px);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: #000000;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  width : 5% ;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
`
const Circle = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 5px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-status/table.js